import { LabelColor } from '@shared/components';

export enum UserStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  INVITATION_PENDING = 'INVITATION_PENDING',
}

export const USER_COLOR_STATUS: Record<UserStatus, LabelColor> = {
  ENABLED: LabelColor.SUCCESS,
  DISABLED: LabelColor.GREY,
  INVITATION_EXPIRED: LabelColor.ERROR,
  INVITATION_PENDING: LabelColor.INFO,
};

export enum TwoFAStatus {
  UNLINKED = 'UNLINKED',
  LINKED = 'LINKED',
  LOCKED = 'LOCKED',
  PENDING = 'PENDING',
}

export const TWO_FA_COLOR_STATUS: Record<TwoFAStatus, LabelColor> = {
  [TwoFAStatus.UNLINKED]: LabelColor.GREY,
  [TwoFAStatus.LINKED]: LabelColor.SUCCESS,
  [TwoFAStatus.LOCKED]: LabelColor.ERROR,
  [TwoFAStatus.PENDING]: LabelColor.GREY,
};

export const TWO_FA_STATUS_TEXT: Record<TwoFAStatus, string> = {
  [TwoFAStatus.UNLINKED]: 'Unverified',
  [TwoFAStatus.LINKED]: 'Verified',
  [TwoFAStatus.LOCKED]: 'Locked',
  [TwoFAStatus.PENDING]: 'Unverified',
};

export const USER_STATUS_TEXT: Record<UserStatus, string> = {
  ENABLED: 'Active',
  DISABLED: 'Inactive',
  INVITATION_EXPIRED: 'Expired',
  INVITATION_PENDING: 'Pending',
};
